<template>
  <form @submit.prevent>
    <div>
      <b-tabs v-if="showLibraryItems" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
        <b-tab :active="showLibraryItems">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{ $t("common.library") }}</span>
          </template>
          <!--           
          <div class="pl-5 pr-5">
            <recommendation-items
              rightPanelId="sidebar-department-recommendation"
              level="department"
              libraryScopedState="department"
              organizationScopedState="organizationDepartment"
            />
          </div> -->

          <LibraryItems
            rightPanelId="sidebar-new-organizationAssetGroupCategory"
            organizationScopedState="organizationAssetGroupCategory"
            libraryScopedState="assetGroupCategory"
            libraryScopedStateCategory="assetGroupCategory"
            :hideSaveAs="true"
          />
        </b-tab>

        <b-tab :active="isEditMode">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <span v-if="isEditMode">{{ $t("common.update") }}</span>
              <span v-else>{{ $t("asset-group-category.new") }}</span>
            </span>
          </template>

          <sweet-input
            :isValid="!$v.form.name.$error"
            @input="$v.form.name.$touch()"
            v-model="form.name"
            type="text"
            layout="vertical"
            :placeholder="$t('asset-group-category.name')"
            :label="$t('asset-group-category.name')"
          />

          <h6 class="mt-4">{{ $t("asset-group-category.admin") }}</h6>

          <!-- <organization-member-select @onAclSelect="onAssetGroupCategoryAdminSelect" /> -->
          <!-- :permissionFilter="['ORGANIZATION_ADMIN']" -->

          <sweet-button
            @click="save()"
            type="submit"
            :loading="isUpdating"
            :disabled="isUpdating || $v.$invalid"
            variant="success"
            icon="mdi mdi-check"
            size="sm"
            buttonClass="mt-2"
          >
            {{ $t("common.save") }}
          </sweet-button>
        </b-tab>
      </b-tabs>
      <div v-else>
        <h2>
          <span v-if="!showLibraryItems && isEditMode">{{ entityName }} {{ $t("common.update") }}</span>
          <span v-else>{{ $t("asset-group-category.new") }}</span>
        </h2>

        <sweet-input
          :isValid="!$v.form.name.$error"
          @input="$v.form.name.$touch()"
          v-model="form.name"
          type="text"
          layout="vertical"
          :placeholder="$t('asset-group-category.name')"
          :label="$t('asset-group-category.name')"
        />

        <h6 class="mt-4">{{ $t("asset-group-category.admin") }}</h6>

        <organization-member-select
          @onAclSelect="onAssetGroupCategoryAdminSelect"
          :permissionFilter="[
            'ORGANIZATION_ADMIN',
            'ORGANIZATION_GDPR_PRODUCT_ADMIN',
            'ORGANIZATION_KVKK_PRODUCT_ADMIN',
            'ORGANIZATION_DDO_PRODUCT_ADMIN',
            'ORGANIZATION_BGYS_PRODUCT_ADMIN',
            'ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN',
            'ORGANIZATION_RISK_ADMIN',
            'ORGANIZATION_LEGAL_ADMIN',
          ]"
          :selected="admin"
        />
        <!-- :permissionFilter="['ORGANIZATION_ADMIN']"  -->

        <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
          {{ $t("common.save") }}
        </sweet-button>

        <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
          {{ $t("common.cancel") }}
        </sweet-button>
        <hr />
      </div>
    </div>
  </form>
</template>

<script>
import LibraryItems from "@cc/library-items";
import OrganizationMemberSelect from "@cc/organization-member-select";
//import RecommendationItems from "@cc/recommendation-items";

import { maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  props: { "hide-library": { type: Boolean }, closeOnSave: { type: Boolean, default: true } },
  components: {
    LibraryItems,
    // RecommendationItems,
    OrganizationMemberSelect,
  },
  data() {
    return {
      form: { name: undefined, admins: undefined },
      formError: undefined,
      entityName: undefined,
      adminChanged: false,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v || Object.keys(v).length === 0) return;

        this.form = { ...this.prepareFormForEdit(v) };
        this.entityName = this.form.name;
      },
    },
    copingEntity: {
      deep: true,
      immediate: true,
      handler(v, o) {
        if (!v || Object.keys(v).length === 0) return;

        this.form = { ...this.prepareFormForEdit(v) };
        this.entityName = this.form.name;
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters["organizationAssetGroupCategory/isUpdating"];
    },
    admin() {
      if (this.form.admins && this.form.admins[0].account) {
        return this.form.admins[0].account;
      } else if (this.form._id) {
        return {
          _id: this.form.admins[0].accountId,
          name: this.form.admins[0].name,
          email: this.form.admins[0].email,
          avatar: this.form.admins[0].avatar,
        };
      }
    },
    editedEntity() {
      return this.$store.getters["organizationAssetGroupCategory/editedEntity"];
    },
    copingEntity() {
      return this.$store.getters["organizationAssetGroupCategory/copingEntity"];
    },
    isEditMode() {
      return this.$store.getters["organizationAssetGroupCategory/isEditMode"];
    },
    showLibraryItems() {
      return !this.hideLibrary && !this.isEditMode && !this.isCoping;
    },
    isCoping() {
      return this.$store.getters["organizationAssetGroupCategory/isCoping"];
    },
  },
  async mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const { data } = await this.$store.dispatch("organizationAssetGroupCategory/save", this.form);
        this.$store.commit("organizationAssetGroupCategory/editedEntity", data);
        this.$emit("onAssetGroupCategorySaved");

        this.adminChanged && this.$emit("onAdminChanged");
        if (this.closeOnSave) {
          this.$root.$emit("bv::toggle::collapse", "sidebar-new-asset-group-category");
        }
        this.form = {};
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    cancel() {
      this.$store.commit("organizationAssetGroupCategory/editedEntity");
      this.$store.commit("organizationAssetGroupCategory/copingEntity");
      // this.$store.dispatch("organizationAssetGroupCategory/resetForm");
    },

    rightPanelClosed() {},

    onAssetGroupCategoryAdminSelect(item) {
      this.form = { ...this.form, admins: [item] };
      this.adminChanged = true;
    },
    onFormSave(item) {
      this.form = { ...this.form, category: { ...item, _id: item.libraryItem } };
    },
  },
};
</script>
